'use client';
import { memoize } from '@s7/memo';
import { cyrb53 } from '@s7/utils';

var hashQuery = memoize(cyrb53);

export { hashQuery };
